import { clientResized } from '../base/responsive-ui/actions';
import { SET_INTERPRETER_TOOLS_MOUNTED, SET_INTERPRETER_TOOLS_OPEN, SET_INTERPRETER_TOOLS_TRANSFER_PENDING } from './actionTypes';
/**
 * The docked panel takes width from the video, so the bar and stage are
 * re-measured whenever it opens, closes or leaves the room.
 *
 * @param {Function} dispatch - The store's dispatch.
 * @returns {void}
 */
function remeasure(dispatch) {
    if (typeof window !== 'undefined') {
        dispatch(clientResized(window.innerWidth, window.innerHeight));
    }
}
/**
 * The room shows (true) or removes (false) the interpreter's Tools panel.
 * Removing it also closes it and clears its live state.
 *
 * @param {boolean} mounted - Whether the panel is in the room.
 * @returns {Function}
 */
export function setInterpreterToolsMounted(mounted) {
    return (dispatch, getState) => {
        const wasOpen = Boolean(getState()['features/interpreter-tools']?.open);
        dispatch({
            type: SET_INTERPRETER_TOOLS_MOUNTED,
            mounted
        });
        if (wasOpen && !mounted) {
            remeasure(dispatch);
        }
    };
}
/**
 * Opens the Tools panel, or minimizes it back to its key.
 *
 * @param {boolean} open - Whether the panel is open.
 * @returns {Function}
 */
export function setInterpreterToolsOpen(open) {
    return (dispatch, getState) => {
        const tools = getState()['features/interpreter-tools'];
        if (!tools?.mounted || tools.open === open) {
            return;
        }
        dispatch({
            type: SET_INTERPRETER_TOOLS_OPEN,
            open
        });
        remeasure(dispatch);
    };
}
/**
 * Opens a minimized panel, or minimizes an open one.
 *
 * @returns {Function}
 */
export function toggleInterpreterTools() {
    return (dispatch, getState) => {
        dispatch(setInterpreterToolsOpen(!getState()['features/interpreter-tools']?.open));
    };
}
/**
 * The Transfer section's attempt started or stopped waiting for acceptance.
 *
 * @param {boolean} pending - Whether a transfer waits for acceptance.
 * @returns {Object}
 */
export function setInterpreterToolsTransferPending(pending) {
    return {
        type: SET_INTERPRETER_TOOLS_TRANSFER_PENDING,
        pending
    };
}
